<template>
  <div class="faq-area ptb-100">
    <div class="container mw-1356">
      <div class="row">
        <div class="col-lg-6">
          <div class="faq-content">
            <span class="top-title">الأسئلة الشائعة</span>
            <h2>اعثر على الإجابات التي تبحث عنها</h2>
          </div>

          <div class="accordion style-two">
            <div
              class="accordion-item"
              v-for="(item, index) in faqItems"
              :key="index"
              :class="{ active: activeIndex === index }"
            >
              <h2 class="accordion-header">
                <button
                  class="accordion-button"
                  type="button"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  @click="toggleAccordion(index)"
                >
                  {{ item.question }}
                </button>
              </h2>
              <div
                class="accordion-collapse collapse show"
                v-show="activeIndex === index"
              >
                <div class="accordion-body">
                  <p>{{ item.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="faq-img">
            <img src="@/assets/images/faq-2.png" alt="faq" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "FAQ",
  setup() {
    const activeIndex = ref<number>(0);

    const faqItems = ref([
      {
        question: "ما هي الأجهزة التي تدعمونها؟",
        answer:
          "لا تحتاج إلى أي خبرة تقنية. ما عليك سوى تنزيل التطبيق على جهازك أو التلفاز الذكي والبدء بالاستمتاع بالمحتوى بسهولة.",
      },
      {
        question: "كيف يمكنني الحصول على الدعم الفني؟",
        answer:
          "فريق الدعم الفني متوفر لمساعدتك والإجابة على استفساراتك وحل أي مشكلة قد تواجهك أثناء استخدام الخدمة.",
      },
      {
        question: "كم من الوقت أحتاج قبل أن أتمكن من استخدام الخدمة؟",
        answer:
          "يتم تفعيل الاشتراك عادةً خلال فترة قصيرة بعد إتمام الطلب، لتتمكن من البدء بالمشاهدة بأسرع وقت ممكن.",
      },
      {
        question: "ما هي سياسة الاسترداد؟",
        answer:
          "يمكنك مراجعة سياسة الاسترداد الخاصة بنا لمعرفة الشروط والأحكام المتعلقة بطلبات الاسترجاع واسترداد المبالغ.",
      },
      {
        question: "ما أنواع اتصالات الإنترنت التي تدعمونها؟",
        answer:
          "تعمل الخدمة مع معظم أنواع اتصالات الإنترنت، بما في ذلك الألياف البصرية والاتصالات المنزلية وشبكات الهاتف المحمول.",
      },
      {
        question: "هل يمكنني ترقية أو تخفيض الباقة في أي وقت؟",
        answer:
          "نعم، يمكنك تغيير الباقة بما يتناسب مع احتياجاتك وفقًا للخيارات المتاحة في حسابك.",
      },
      {
        question: "ما الإجراءات المتبعة لضمان الأمان والحماية؟",
        answer:
          "نعتمد على تقنيات وإجراءات أمنية حديثة للمساعدة في حماية بيانات المستخدمين وضمان تجربة استخدام آمنة.",
      },
      {
        question: "ما الميزات الإضافية المتوفرة مع الباقات؟",
        answer:
          "قد تتضمن الباقات مزايا إضافية مثل الوصول إلى محتوى حصري، ودعم فني مميز، وخيارات مشاهدة متعددة حسب نوع الباقة.",
      },
    ]);

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    return {
      faqItems,
      activeIndex,
      toggleAccordion,
    };
  },
});
</script>